import { shouldPolyfill as shouldPolyfillCanonicalLocales } from "@formatjs/intl-getcanonicallocales/should-polyfill.js";
import { shouldPolyfill as shouldPolyfillLocale } from "@formatjs/intl-locale/should-polyfill.js";
import { shouldPolyfill as shouldPolyfillPlurals } from "@formatjs/intl-pluralrules/should-polyfill.js";
import { polyfillCountryFlagEmojis } from "country-flag-emoji-polyfill";

async function polyfill() {
  if (shouldPolyfillLocale()) {
    await import("@formatjs/intl-locale/polyfill-force.js");
  }

  if (shouldPolyfillCanonicalLocales()) {
    await import("@formatjs/intl-getcanonicallocales/polyfill-force.js");
  }

  if (shouldPolyfillPlurals()) {
    await import("@formatjs/intl-pluralrules/polyfill-force.js");
    await import("@formatjs/intl-pluralrules/locale-data/en.js");
  }

  polyfillCountryFlagEmojis();
}

export default polyfill;
